<template>
  <div data-nosnippet class="card h-100 mb-3 card-light text-lg-start">
    <button class="video-thumbnail d-block bg-transparent border-0" :aria-label="item.title" data-bs-toggle="modal" :data-bs-target="`#video-${ item.id }-modal`">
      <div class="image-wrap aspect-ratio-box aspect-ratio-box-16x9">
        <img :src="item.image.url" :alt="item.image.alt" class="aspect-ratio-box-inner"/>
      </div>
      <slot name="video-play-icon"></slot>
    </button>
    <div class="card-body d-flex flex-column py-3">
      <h3 class="card-title mb-3 text-capitalize">
        <a class="text-black" href="#" data-bs-toggle="modal" :data-bs-target="`#video-${ item.id }-modal`">
          {{ item.title }}
        </a>
      </h3>
      <div class="rte">
        {{ item.description }}
      </div>
    </div>
  </div>
  <div data-nosnippet class="modal modal-video" tabindex="-1" :id="`video-${ item.id }-modal`">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <strong class="modal-title h4 d-block">{{ item.title }}</strong>
          <button type="button" class="bg-transparent border-0" data-bs-dismiss="modal" aria-label="Close">
            <slot name="modal-close-button"></slot>
          </button>
        </div>
        <div class="modal-body">
          <div class="media-embed aspect-ratio-box aspect-ratio-box-16x9">
            <div class="aspect-ratio-box-inner" v-html="item.embed"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['item']
  }
</script>
